/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';;
class SplashScreenModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }
    componentDidMount() {
    }
    
    
    render() {       
        
        return (
            <>
                <div id="splashscreenmodalpopup" className="modal fade show sign-up-form depositpopup " style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className={this.state.selectedPage === "paymentselection" ? "modal-dialog  modal-dialog-scrollable modal-sm" : "modal-dialog  modal-dialog-scrollable modal-sm"} >
                        <div className="modal-content hebebox b-0">
                            {/* <div className="modal-header hebebox">
                                <button onClick={() => { this.props.hidePopup() }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true">×</button>
                            </div> */}
                            <div className="modal-body p-0" id='content'>
                                <button onClick={() => { this.props.hidePopup() }} type="button" className="close text-black btncloseset" data-dismiss="modal" aria-hidden="true">×</button>
                                <img style={{ width: "100%" }} src={BASE_IMAGE_PATH + "/casino/banner/images/asiacup-popup.webp"} alt={""}></img>
                            </div>                            
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
                </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SplashScreenModal);
